export const DESC_SETTING = {
  HIDE_ON_MOBILE: 'Hide on Mobile',
  HIDE_ON_DESKTOP: 'Hide on Desktop'
} as const;

export type DescriptionOption = typeof DESC_SETTING[keyof typeof DESC_SETTING];
